const RETRY_TIMEOUT = 500;
// retry these codes on GET requests
export const RETRY_ON_GET_STATUS_CODES = [0, 502, 503, 504, 520, 598, 599];
// these are errors returned by Cloudflare, and we should retry them even if it's not a GET request, because the backend didn't respond at all
export const RETRY_ALWAYS_STATUS_CODES = [
  521, 522, 523, 524, 525, 526, 527, 530,
];
// don't bother logging these codes (errors due to client mistakes)
const NEVER_LOGGED_STATUS_CODES = [-1, 400, 401, 404, 423];

// these codes mean a network error has happened somewhere
export const NETWORK_ERROR_CODES = [-1].concat(
  RETRY_ON_GET_STATUS_CODES,
  RETRY_ALWAYS_STATUS_CODES,
);

/**
 * This interceptor will automatically retry any GET requests that have one of the
 * status codes listed above.  It will only retry once until there is at least one successful request.
 * It has a timeout between the first and follow-up request.
 */
export const autoRetryInterceptorModule = angular
  .module('Q.interceptors.auto-retry-interceptor', [])

  .factory('autoRetryInterceptor', function ($q, $injector, $timeout, $log) {
    let shouldRetry = true;

    return {
      responseError(response) {
        const config = (response && response.config) || {};
        const methodIsGet = config.method === 'GET';
        const invalidStatus = methodIsGet && response.status < 0;
        const validGetRequest =
          methodIsGet &&
          RETRY_ON_GET_STATUS_CODES.indexOf(response.status) !== -1;
        const validOtherRequest =
          RETRY_ALWAYS_STATUS_CODES.indexOf(response.status) !== -1;

        if (
          shouldRetry &&
          config.autoRetry !== false &&
          (invalidStatus || validGetRequest || validOtherRequest)
        ) {
          shouldRetry = false;

          return $timeout(() => {
            const $http = $injector.get('$http');
            return $http(response.config);
          }, RETRY_TIMEOUT);
        } else if (
          response &&
          NEVER_LOGGED_STATUS_CODES.indexOf(response.status) === -1 &&
          config.ignoreNetworkErrors !== true
        ) {
          // log to sentry
          $log.error(
            `$http error: ${response.status} - ${response.statusText}`,
            response,
          );
        }

        // give up
        return $q.reject(response);
      },

      response(response) {
        shouldRetry = true;
        // Leaving this here (commented out) as a tool for future testing.
        // To use: set any values on window.mock, such as status, statusText, or data, and they'll override
        // the actual values for testing handling of http responses
        // if(window.mock) {
        // 	angular.extend(response, window.mock);
        // 	$log.debug('[mocked http response]', response);
        // }
        return response;
      },
    };
  })

  .config(function ($httpProvider) {
    $httpProvider.interceptors.push('autoRetryInterceptor');
  });
